import { exists, translate } from "application/functions";
import { filter, includes } from "ramda";

export default function validateData(value) {
  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var mobileFormat = /^[+]?\d{9,}$/;

  const errors = { messages: [], keys: [] };

  const requiredDataKeys = ["name.value", "surname.value", "email.value", "mobile.value"];

  const unanswered = filter((k) => !exists(value[k]), requiredDataKeys);

  const answered = filter((k) => exists(value[k]), requiredDataKeys);

  if (exists(unanswered)) {
    // errors.messages = [...errors.messages, translate("error.emptyFields")];
    errors.keys = [...errors.keys, ...unanswered];
  }

  answered.forEach((answer) => {
    const value = document.getElementsByName(answer)[0].value;
    switch (answer) {
      case "email.value":
        if (!value.match(mailFormat)) {
          errors.messages = [...errors.messages, ...[translate("field.email")]];
          errors.keys = [...errors.keys, ...[answer]];
        }
        break;

      case "mobile.value":
        if (!value.match(mobileFormat)) {
          errors.messages = [...errors.messages, ...[translate("field.mobile")]];
          errors.keys = [...errors.keys, ...[answer]];
        }
        break;
      default:
        break;
    }
  });

  if (exists(errors.keys)) {
    errors.messages = errors.messages.reduce((acc, m) => {
      return includes(m, acc) ? acc : [...acc, m];
    }, []);
    return errors;
  }
  return null;
}
